<template>
<div class="navbar-item ">
  <span class="notification-menu">
      <div class="dropdown is-hoverable is-left">
        <div class="dropdown-trigger">
          <button class="button btn-transparent has-text-primary has-text-weight-bold" aria-haspopup="true" aria-controls="dropdown-menu4">
            <span><i class="fa-lg fas fa-bell"></i> <span class="count-text" v-if="count > 0" >{{count}}</span></span>
            <span class="icon is-small">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </button>
        </div>
        <div class="overflow-hidden dropdown-menu has-background-primary radius-md" id="dropdown-menu4" role="menu">
          <div class="dropdown-content has-background-primary" id="notification_content" v-if="count > 0">
            <div class="dropdown-item" v-for="(item , index) in notifications" :key="`notification-${index}`">
              <a @click="openModal(item)" href="#" class="notification-item" :class="[item.seen === 0 ? 'not-seen':'seen']">
                <div class="notification-text">
                  <p>{{item.title}}</p>
                  <p>{{item.body}}</p>
                </div>
                <span class="notification-time">{{item.time}}</span>
              </a>
            </div>
          </div>
          <div class="dropdown-content has-background-primary" id="notification_content" v-else>
            <div class="dropdown-item has-text-white">
              <p>{{ t('no_notification') }}</p>
            </div>  
          </div>
        </div>
      </div>
     </span>
     <div v-if="openedOrder" class="modal modal-notification" :class="{ 'is-active':  controlDetailsModal}">
			<div class="modal-background is-white"></div>
			<div class="card modal-content">
				<div class="overflow-hidden has-text-centered">
					<div class="has-background-warning has-text-white has-text-weight-bold p5">
						<p class="has-text-centered is-size-6">
                {{ t('details') }}
						</p>
					</div>
					<div class="p25 has-text-right" v-if="role === 'merchant'">
            <div class="columns is-vcentered">
              <div class="column is-3">
                <figure class="mr-auto image image-contain-height is-128x128">
                  <lazy-load
                  src="/front/img/spinner.svg"
                  :lazy-src="openedOrder.image"
                  :lazy-srcset="openedOrder.image"
                  background-color="transparent"
                  alt="slider" class="hvr-grow"
                  />
                </figure>
              </div>
              <div class="column is-9">
                <p class="mb20 has-text-warning is-size-6 has-text-weight-bold">{{openedOrder.product_name}}</p>
                <p class="has-text-grey">{{ t('client_name') }}  : <span class="has-text-primary">{{ openedOrder.client_name }}</span></p>
                <p class="has-text-grey">{{ t('client_phone') }}  : <span class="has-text-primary">{{ openedOrder.client_phone }}</span></p>
                <p class="has-text-grey">{{ t('product_price') }}  : <span class="has-text-primary">{{ openedOrder.subtotal }} {{ t('currency')}}</span></p>
                <p v-if="openedOrder.category_type === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ openedOrder.quantity }}</span></p>
                <p v-if="openedOrder.category_type === 'date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ openedOrder.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ openedOrder.finish_date }}
                  </span>
                </p>
                <p v-if="openedOrder.category_type === 'date_time'" class="has-text-grey">
                  {{ t('date_time')}}:
                  <span class="has-text-primary">
                    {{ openedOrder.start_date }} {{ openedOrder.start_time }}
                  </span>
                </p>
                <p v-if="openedOrder.category_type === 'fixed_date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ openedOrder.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ openedOrder.finish_date }}
                  </span>
                </p>
                <p class="has-text-grey">{{ t('total')}} : <span class="has-text-primary">{{ openedOrder.total }} {{ t('currency')}}</span></p>
              </div>
            </div>
          </div>
          <div class="p25 has-text-right" v-else>
            <div class="columns is-vcentered">
              <div class="column is-3">
                <figure class="mr-auto image image-contain-height is-128x128">
                  <lazy-load
                  src="/front/img/spinner.svg"
                  :lazy-src="openedOrder.image"
                  :lazy-srcset="openedOrder.image"
                  background-color="transparent"
                  alt="slider" class="hvr-grow"
                  />
                </figure>
              </div>
              <div class="column is-9">
                <p class="mb20 has-text-warning is-size-6 has-text-weight-bold">{{openedOrder.product_name}}</p>
                <p class="has-text-grey"> {{ t('category_name') }}  : <span class="has-text-primary">{{ openedOrder.category_name }}</span></p>
                <p class="has-text-grey">{{ t('merchant_name') }}  : <span class="has-text-primary">{{ openedOrder.merchant_name }}</span></p>
                <p class="has-text-grey">{{ t('product_price') }}  : <span class="has-text-primary">{{ openedOrder.subtotal }} {{ t('currency')}}</span></p>
                <p v-if="openedOrder.category_type === 'quantity'" class="has-text-grey">{{ t('quantity') }} : <span class="has-text-primary">{{ openedOrder.quantity }}</span></p>
                <p v-if="openedOrder.category_type === 'date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ openedOrder.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ openedOrder.finish_date }}
                  </span>
                </p>
                <p v-if="openedOrder.category_type === 'date_time'" class="has-text-grey">
                  {{ t('date_time')}}:
                  <span class="has-text-primary">
                    {{ openedOrder.start_date }} {{ openedOrder.start_time }}
                  </span>
                </p>
                <p v-if="openedOrder.category_type === 'fixed_date'" class="has-text-grey">
                  <span class="has-text-primary">
                    <small class="has-text-grey">{{ t('from')}}:</small> {{ openedOrder.start_date }}<br/>
                    <small class="has-text-grey">{{ t('to')}}:</small> {{ openedOrder.finish_date }}
                  </span>
                </p>
                <p class="has-text-grey">{{ t('total')}} : <span class="has-text-primary">{{ openedOrder.total }} {{ t('currency')}}</span></p>
              </div>
            </div>
          </div>
				</div>
			</div>
			<button class="modal-close is-large has-background-warning" aria-label="close" @click="closeModal"></button>
		</div>
  </div>
</template>
<script>
  import axios from 'axios';
  import trans from "./translation/orders.json";
  export default {
    name: "Notifications",
    props: {
        siteLocale:{
            type: String,
            required: true
        },
        role:{
            type: String,
            required: false
        },
        url: {
            type: String,
            required: true
        },
        counter: {
            type: Number,
            required: true,
            default:0
        },
        
    },
    locales: trans,
    data() {
      return {
          notifications: [],
          currentPage: 0,
          fetching: false,
          nextUrl : String,
          loadMore : true,
          timer: '',
          controlDetailsModal: false,
          openedOrder: null,
          count:0
      };
    },
    computed: {
      busy() {
        return this.fetching
      },
      // count(){
      //   return this.notifications.filter(item => item.seen == 0 ).length;
      // }
    },
    created(){
      this.nextUrl = this.url;
      this.count = this.counter
      this.notifications = [];
      // this.timer = setInterval(this.newNotifications, 40000);
      // this.newNotifications();
      this.fetchEventsList();
    },
    mounted() {
      this.$translate.setLang(this.siteLocale);
      const listElm = document.querySelector('#notification_content');
      listElm.addEventListener('scroll', e => {
        if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          this.fetchEventsList();
          console.log(listElm.scrollTop + listElm.clientHeight, listElm.scrollHeight)
        }
      });
    },
    methods: {
     async fetchEventsList () {
        this.currentPage++;
        this.fetching = true;
        if(this.nextUrl != null){
          let config = {headers: {locale: this.siteLocale}};
          await axios.get(this.nextUrl, config).then(({ data }) => {
              this.notifications.push(...data.data);
              if(data.links.next != null) {
                  this.nextUrl = data.links.next;
              } else {
                  this.nextUrl = data.links.next;
              }
              this.fetching = false;
          });
        }
        else{
            this.loadMore = false;
        }
      },
      async newNotifications(){
        this.currentPage = 0;
        let config = {headers: {locale: this.siteLocale}};
        await axios.get(this.url, config).then(({ data }) => {
            this.notifications = data.data;
            this.nextUrl = data.links.next;
            this.fetching = false;
        });
      },
      cancelAutoUpdate () {
        clearInterval(this.timer);
      },
      openModal(item){
        this.controlDetailsModal = true
        this.openedOrder = item.order
        item.seen = 1
        this.count --
        axios.patch(`/order_notifications/${item.id}`).then(({ data }) => {})
      },
      closeModal(){
        this.controlDetailsModal = false
      }
    },
    beforeDestroy () {
      this.cancelAutoUpdate();
    }
  }
</script>
<style lang="scss">
.modal-notification{
    height: 100vh;
}
.notification-menu{
  .dropdown-menu{
    min-width: 300px;
  }
  .dropdown-item{
    &:not(:last-of-type){
      border-bottom: 1px solid #fff;
    }
    .notification-item{
      color: #fff;
      margin: 10px 0 0 0px;
      padding-bottom: 15px;
      display: block;
      .notification-text{
        display: block;
        font-size: 0.6rem;
      }
      .notification-time{
        font-size: 0.5rem;
        float: left;
      }
    }
    .notification-item.not-seen{
      color:#f9d350
    }
  }
  .dropdown-content{
    max-height: 250px;
    overflow-y: auto;

  }
  .dropdown-content::-webkit-scrollbar {
    width: .3em;
    border-radius: 8px;
  }

  .dropdown-content::-webkit-scrollbar-track {
    background-color: #dedede;
  }

  .dropdown-content::-webkit-scrollbar-thumb {
    background-color: #f8c208;
  }
  .count-text{
    position: absolute;
    height: 20px;
    width: 20px;
    background-color: #f8c208;
    border-radius: 100%;
    top: 2px;
    right:2px;
    font-size: 11px;
    line-height: 20px;
    display: block;
  }
}
</style>
